// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__zcHyd","clickable":"Icon_clickable__Eh0EB","container":"Icon_container__yb333","overlay":"Icon_overlay__sHe8B"};